import { Pipe, PipeTransform } from '@angular/core';

// Human-readable labels for the message-tab buttons.
//
// The backend ships snake_case message names (input / output /
// provider_request / provider_response / raw_request / …). Rendering
// them verbatim is unfriendly, so this pipe maps the known names to
// Title Case and falls back to a generic snake_case → Title Case
// transform — that way ANY current or future message name renders as a
// human title with no further code changes.
//
// OrderChangeNotif is a special case. It is NOT an API request our
// platform initiated: it is an asynchronous CALLBACK the provider
// pushes to us, which our platform then acknowledges. The provider's
// inbound notif is captured as the "provider_request" message and our
// outbound acknowledgement as the "provider_response" message, so for
// this method those two names are relabelled accordingly.
const GENERIC_LABELS: Record<string, string> = {
  input: 'Request',
  output: 'Response',
  provider_request: 'Provider Request',
  provider_response: 'Provider Response',
};

const ORDER_CHANGE_NOTIF_LABELS: Record<string, string> = {
  provider_request: 'Provider Callback',
  provider_response: 'Acknowledgement',
};

// OrderChangeNotif is captured under the OrderChange method family; the
// notif leg is distinguished by ProviderMethod. Match either so the
// callback labelling holds however the backend tags it. Exported as the
// single source of truth for "this is a provider-pushed callback, not a
// request our platform made" — reused by IsProviderCallbackPipe.
export function isOrderChangeNotif(method?: string | null): boolean {
  if (!method) return false;
  return method === 'OrderChangeNotif' || method.includes('OrderChangeNotif');
}

function titleCase(raw: string): string {
  return raw
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

@Pipe({
  name: 'messageTabLabel',
})
export class MessageTabLabelPipe implements PipeTransform {
  transform(name: string | null | undefined, method?: string | null): string {
    if (!name) return '';
    if (isOrderChangeNotif(method) && ORDER_CHANGE_NOTIF_LABELS[name]) {
      return ORDER_CHANGE_NOTIF_LABELS[name];
    }
    return GENERIC_LABELS[name] ?? titleCase(name);
  }
}
